// Re-exports — kept for backwards compatibility with existing imports.
export { api, API, openProtectedFile } from "@/lib/auth";

export const fmtINR = (n, symbol = "₹") =>
  symbol +
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

export const fmtCurrency = (n, currency = "INR", symbol = "₹") => {
  const v = Number(n || 0);
  if (currency === "INR") {
    if (v >= 1e7) return symbol + (v / 1e7).toFixed(2) + " Cr";
    if (v >= 1e5) return symbol + (v / 1e5).toFixed(2) + " L";
    if (v >= 1e3) return symbol + (v / 1e3).toFixed(1) + " K";
    return symbol + v.toFixed(0);
  }
  if (v >= 1e6) return symbol + (v / 1e6).toFixed(2) + " M";
  if (v >= 1e3) return symbol + (v / 1e3).toFixed(1) + " K";
  return symbol + v.toFixed(0);
};

// Backwards-compat alias
export const fmtCompactINR = (n) => fmtCurrency(n, "INR", "₹");

export const STAGES = [
  { key: "lead", label: "New", bg: "#F9F8F6", accent: "#6B6965" },
  { key: "quoted", label: "Quoted", bg: "#F0F4F8", accent: "#1E3A5F" },
  { key: "sample_sent", label: "Sample Sent", bg: "#FFF0E6", accent: "#C85A17" },
  { key: "approved", label: "Approved", bg: "#FAF3E0", accent: "#946200" },
  { key: "not_approved", label: "Not Approved", bg: "#F5EDED", accent: "#B45309" },
  { key: "won", label: "Won", bg: "#EAF0EA", accent: "#2F4F4F" },
  { key: "lost", label: "Lost", bg: "#F5EDED", accent: "#B91C1C" },
];

export const stageMeta = (k) => STAGES.find((s) => s.key === k) || STAGES[0];
